function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.799384 38.977C0.00583887 40.3102 0.966515 42 2.51797 42H45.482C47.0335 42 47.9942 40.3102 47.2006 38.977L25.7186 2.88722C24.9432 1.58451 23.0568 1.58451 22.2814 2.88722L0.799384 38.977Z",
  fill: "#F2994A"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.696 36V34.08H22.208L28.016 27.048C28.928 25.92 29.432 24.816 29.432 23.496C29.432 22.44 29.168 21.624 28.664 20.904C27.824 19.728 26.336 18.984 24.512 18.984C21.56 18.984 19.52 20.952 19.52 23.856H21.632C21.632 21.648 23.048 20.832 24.536 20.832C26.288 20.832 27.344 21.816 27.344 23.52C27.344 24.384 27.08 25.152 26.432 25.92L19.544 34.248V36H29.696Z",
  fill: "white"
});

var Svg2Medium = function Svg2Medium(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg2Medium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/2-medium.96b745fc.svg";
export { ForwardRef as ReactComponent };